import React from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import Modal from '@bt-react/components/Modal'
import Button from '@bt-react/components/Button'
import styles from './SlidesUploadModal.module.scss'
import { SlidesUploadModalProps } from './types'
import { FileDropArea } from './FileDropArea'
import { FileList } from './FileList'
import RadioButton from '@bt-react/components/RadioButton'
import classNames from 'classnames'

const PPT_FILE_TYPE = 'application/vnd.ms-powerpoint'
const PPTX_FILE_TYPE = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'

class SlidesUploadModal extends React.Component<SlidesUploadModalProps> {

    state = {
      error: null,
      selectedFile: null
    }

    handleDrop = (files) => {

      this.setState({
        error: null
      })
      if (files.length) {

        this.setState({
          selectedFile: files[0]
        })

      }

    }

    onDropRejected = ([file]: File[]) => {

      if (![PPT_FILE_TYPE, PPTX_FILE_TYPE].includes(file.type)) {

        return this.setState({
          error: 'The file was the wrong format, please use a PowerPoint file'
        })

      }

      if (file.size > this.props.slidesSizeLimitBytes) {

        return this.setState({
          error: `File exceeded ${this.props.slidesSizeLimitBytes / 1e+6}Mb please try a smaller file`
        })

      }

    }

    clearFile = () => {

      this.setState({
        selectedFile: null,
        error: null
      })

    }

    componentDidMount () {

      if (this.props.serviceError) {

        this.setState({
          error: this.props.serviceError
        })

      }

    }

    componentDidUpdate (prevProps) {

      if (this.props.serviceError !== prevProps.serviceError) {

        this.setState({
          error: this.props.serviceError
        })

      }

    }

    errorMessage = () => {

      return (
        <div className={styles['error-message']}>
          <Icon colour={IconType.colour.white} name={IconType.iconName.danger}/>
                &nbsp;&nbsp;{this.state.error}
        </div>)

    }

    onDelete = () => {

      this.setState({
        error: null,
        selectedFile: null
      })

    }

    onUploadClick = () => {

      this.props.onUploadClick && this.props.onUploadClick(this.state.selectedFile)

    }

    render () {

      return <Modal isOpen={true} concise={true} dataBdd='upload-slides-modal'>
        {this.state.error && this.errorMessage()}
        <Modal.Body>
          <div className={classNames(styles['heading'], styles['heading-text-400'])} data-bdd='upload-slides-modal-header'>Upload slides</div>
          {this.state.selectedFile
            ? <>
                <FileList file={this.state.selectedFile} onDelete={this.clearFile} />
                <div className={styles['slides-feature-image-checkbox-container']}>
                  <RadioButton
                    id='slides-feature-image-check'
                    name='feature-image-check'
                    onChange={this.props.onSetAsFeatureImage}
                    value='true'
                    checked={this.props.setAsFeatureImage}
                    dataBdd='slides-feature-image-check'
                    label='Use first slide as the new feature image'
                  />
                  <RadioButton
                    id='slides-feature-image-check-false'
                    name='feature-image-check'
                    onChange={this.props.onUnsetAsFeatureImage}
                    value='false'
                    checked={!this.props.setAsFeatureImage}
                    dataBdd='slides-feature-image-check-false'
                    label='Keep current feature image'
                  />
                </div>
              </>
            : <FileDropArea
              onDropRejected={this.onDropRejected}
              handleDrop={this.handleDrop}
              slidesSizeLimitBytes={this.props.slidesSizeLimitBytes}
            />}
        </Modal.Body>
        <Modal.Footer className={styles['footer']}>
          <Button
            dataBdd="cancel-button"
            onClick={this.props.onCancelClick}
            color={IconType.colour.link}
            text={'Cancel'}
          />
          {this.state.selectedFile && <Button
            dataBdd="upload-button"
            onClick={this.onUploadClick}
            color={IconType.colour.primary}
            text={'Upload'}
          />}
        </Modal.Footer>
      </Modal>

    }

}

export default SlidesUploadModal
